/** Shared confirm / toast helpers for admin panel actions. */
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

function showToast(vm, { title, text, variant, icon, timeout }) {
  if (!vm || typeof vm.$toast !== 'function') return null
  return vm.$toast(
    {
      component: ToastificationContent,
      props: {
        title,
        text,
        variant,
        icon,
      },
    },
    {
      timeout,
      position: 'top-right',
    },
  )
}

export function confirmAction(vm, { title, text, confirmButtonText = 'Yes' }, onConfirm) {
  return vm.$swal({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1',
    },
    buttonsStyling: false,
  }).then(result => {
    if (result.isConfirmed && typeof onConfirm === 'function') {
      return onConfirm()
    }
    return null
  })
}

export function notifySuccess(vm, text, title = 'Done') {
  return showToast(vm, {
    title,
    text,
    variant: 'success',
    icon: 'CheckIcon',
    timeout: 3000,
  })
}

export function notifyInfo(vm, text, title = 'Notice') {
  return showToast(vm, {
    title,
    text,
    variant: 'info',
    icon: 'InfoIcon',
    timeout: 3000,
  })
}

export function notifyError(vm, text, title = 'Error') {
  return showToast(vm, {
    title,
    text,
    variant: 'danger',
    icon: 'AlertCircleIcon',
    timeout: 4000,
  })
}

/** Prompt for rejection reason; returns trimmed string or null if cancelled. */
export function promptRejectReason(vm, { title = 'Rejection reason', text = 'Please provide a reason for rejection (at least 10 characters).' } = {}) {
  return vm.$swal({
    title,
    text,
    input: 'textarea',
    inputPlaceholder: 'Enter rejection reason (min. 10 characters)...',
    inputAttributes: { 'aria-label': 'Rejection reason' },
    showCancelButton: true,
    confirmButtonText: 'Reject',
    cancelButtonText: 'Cancel',
    customClass: {
      confirmButton: 'btn btn-danger',
      cancelButton: 'btn btn-outline-secondary ml-1',
    },
    buttonsStyling: false,
    inputValidator: value => {
      const trimmed = String(value || '').trim()
      if (!trimmed) {
        return 'A rejection reason is required.'
      }
      if (trimmed.length < 10) {
        return 'Please enter at least 10 characters.'
      }
      return null
    },
  }).then(result => {
    if (result.isConfirmed && result.value) {
      return String(result.value).trim()
    }
    return null
  })
}
